export const resolveOrderProductId = (products, productName) => {
  if (!Array.isArray(products) || !productName) return null;
  const normalizeText = (value) => String(value ?? '')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .trim();
  const normalized = normalizeText(productName);
  const matched = products.find(
    (p) => p?.id != null && normalizeText(p.name) === normalized,
  );
  return matched?.id != null ? String(matched.id) : null;
};
